import React, { Component } from 'react';

import Layout from '../../components/Layout/Layout';
import Button from '../../components/UI/Button/index.tsx';
import Input from '../../components/UI/CustomInputField/index';
import layoutCSS from '../../components/Layout/Layout.module.scss';
import Message from '../../components/UI/Message';

class Login extends Component {
  state = { password: '' };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.analytics.trackEvent('Login Password Viewed');
    if (!this.props.tempPhoneNumber) {
      this.props.history.replace('/');
    }
  }

  onChange = value => {
    this.setState({ password: value });
  };

  submitPassword = e => {
    e.preventDefault();

    this.props.login({
      phoneNumber: this.props.tempPhoneNumber,
      password: this.state.password,
      accessToken: this.props.regAccessToken
    });
  };

  render() {
    return (
      <div>
        <Layout>
          <div className={layoutCSS.layoutWrapper}>
            <h1 data-e2e="login-header">Welcome back!</h1>
            <h2 data-e2e="login-subheader">
              We already have an account with your phone number. Enter your
              password to continue registering.
            </h2>
            <Message
              error={this.props.error || this.props.timeoutError}
              text={this.props.message || this.props.timeoutError}
            />
            <form style={{ marginTop: '30px' }} autoComplete="off">
              <Input
                id="password"
                type="password"
                placeholder="Enter password here"
                onChange={this.onChange}
                data-e2e="password"
              />
              <a
                onClick={() => this.props.setNextRegStep('forgot_password')}
                style={{ fontSize: '18px' }}
              >
                Forgot your Password?
              </a>
              <Button
                text="Next"
                disabled={this.state.password.length === 0}
                loading={this.props.loading}
                onClick={this.submitPassword}
              />
            </form>
          </div>
        </Layout>
      </div>
    );
  }
}

export default Login;
